import { Box, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export type ScheduleGridTooltipProps = {
  content: ReactNode;
  children: ReactNode;
  width?: number;
};

export const ScheduleGridTooltip = ({
  content,
  children,
  width = 200,
}: ScheduleGridTooltipProps) => {
  return (
    <Tooltip
      title={content}
      componentsProps={{
        tooltip: { sx: { margin: 0, padding: 1.25, minWidth: width, maxWidth: width } },
      }}
      arrow
    >
      <Box sx={{ height: '100%', overflow: 'hidden' }}>{children}</Box>
    </Tooltip>
  );
};
